import React, {useEffect, useState} from "react";
import {gitRepoConsoleUrl, gitToken} from "../../constants";
import Cookies from 'js-cookie';
import {Link} from "react-router-dom";

const GitComments = () => {
    const [gitComment, setGitComment] = useState(null);
    useEffect(() => {

        //if (!getGitCookie()) {
            getGitComments();
        //}

    }, [])


    const getGitComments = () => {
        fetch(`${gitRepoConsoleUrl}/repository/tags/`, {
            method: "GET",
            headers: {
                "PRIVATE-TOKEN": gitToken
            },
        })
            .then(res=>res.json())
            .then(([data])=>{
                const cookieValue = getGitCookie();
                setGitComment(data.target);
                if (cookieValue !== data.target) {
                    Cookies.remove('git-day');
                    setGitCookie(data.target);
                }
            })
        ;
    }

    const closeGitComments = () => {
        setDayCookie('true');
        setGitComment(null);
    }

    const setGitCookie = (msg) => {
        Cookies.set('git-comment', msg, { expires: 150 });
    };
    const getGitCookie = () => {
        const cookieValue = Cookies.get('git-comment');
        return cookieValue;
    };


    const setDayCookie = (text) => {
        Cookies.set('git-day', text, { expires: 365 });
    };

    const getDayCookie = () => {
        const cookieValue = Cookies.get('git-day');
        return cookieValue;
    };


    return (
        <>
            {/*
                        ┌───────────────────────────────────────────────┐
                        │ => Get tag comments from git repo and showing │
                        │    in UI acknowledge user what upcoming in    │
                        │    future                                     │
                        └───────────────────────────────────────────────┘
            */}

            { !getDayCookie() && gitComment && <div className="small-notice" style={{margin: ".5% 1% 1% 1%", padding: ".8em 0.5em"}}>
                New version has been released for Adgrid. <Link to="whats-new">Click here</Link> for release notes.
                <button
                    className="delete-btn"
                    style={{right:"2%", top: "15px", position: "absolute", cursor: "pointer", color: "red", border: "1px solid #858585", background: "#ffffff"}}
                    onClick={closeGitComments}
                >⨉</button>
            </div> }
        </>
    );
}

export default GitComments;
